import { FC, useState, FormEvent } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Button, Typography, Divider } from "@material-ui/core";
import RadioBtn from "./RadioBtn"
import { ReactComponent as ArrowLeftIcon } from 'src/assets/arrow-left.svg';
import { BlockTypesLabels, AvailableBlockTypesLabels } from "src/config/constants"

interface BlockTypeFormProps {
  targetBlock: Block;
  onGoBack: () => void;
  onClose: () => void;
  onChangeBlockType: (newBlockType: BlockType) => void;
};

const BlockTypeForm: FC<BlockTypeFormProps> = ({ targetBlock, onGoBack, onClose, onChangeBlockType }) => {
    const classes = useStyles();
    const [blockTypeSelected, setBlockTypeSelected] = useState<BlockType>(targetBlock.type)

    const blockTypes = Object.entries(BlockTypesLabels).filter((entry) => {
      const type = entry[0] as BlockType
      return AvailableBlockTypesLabels[type]
    }).map(entry => {
      const type = entry[0] as BlockType
      const label = entry[1]
      return {
        id: type,
        label
      }
    })

    const onSelectBlockType = (event: FormEvent<HTMLFormElement>) => {
      setBlockTypeSelected((event.target as HTMLInputElement).id as BlockType)
    }

    const onSave = () => {
      onChangeBlockType(blockTypeSelected)
      // TODO: don't close the modal when the block type is change.
      // the issue is that when you change the block type the modal
      // changes its position to the (0,0) coordinate on the canvas.
      onClose()
    }

    return (
      <div>
        <div className={classes.header}>
          <button className={classes.iconButton} onClick={onGoBack}>
            <ArrowLeftIcon />
          </button>
          <Typography className={classes.headerTitle}>Cambiar bloque</Typography>
        </div>
        <Divider className={classes.divider}/>
        <form onChange={onSelectBlockType}>
          {blockTypes.map((blockType) => {
            return (
              <RadioBtn
                id={blockType.id}
                value={blockType.id}
                checked={blockTypeSelected === blockType.id}
                label={blockType.label}
                key={`block-type-${blockType.id}`} />
            );
          })}
        </form>
        <Button
          className={classes.saveButton}
          variant="contained"
          onClick={onSave}>
          Guardar cambios
        </Button>
      </div>
    );
};

BlockTypeForm.defaultProps = { };

export default BlockTypeForm;

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    display: "flex",
    alignItems: "center",
  },
  divider: {
    margin: "20px 0",
  },
  headerTitle: {
    marginLeft: "14px",
    fontSize: "14px",
    fontWeight: 500,
  },
  iconButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  saveButton: {
    width: "100%",
    margin: "24px 0 0 0",
    borderRadius: "8px",
    boxShadow: "0 4px 6px 0 rgba(68, 83, 226, 0.29)",
    backgroundColor: "#37ee8c",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 600,
    color: "#1d262c",
    textTransform: "none",

    "&:hover": {
      backgroundColor: "#37ee8c",
    }
  },
}));
